import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import style from "./cardHeaderStyle";

function CardHeader({ ...props }) {
    const { classes, className, children, plain, color, ...rest } = props;
    const colorClass = classes[color + "CardHeader"];
    const cardHeaderClasses = classNames({
        [classes.cardHeader]: true,
        [classes.cardHeaderPlain]: plain,
        [colorClass]: color,
        [className]: className !== undefined
    });
    return (
        <div className={cardHeaderClasses} {...rest}>
            {children}
        </div>
    );
}

CardHeader.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    plain: PropTypes.bool,
    color: PropTypes.oneOf(["warning", "success", "danger", "info", "primary"]),
};

export default withStyles(style)(CardHeader);